<template>
  <section class="container--large policy">
    <h1 class="mt-4 mt-md-5 mb-4 fw-bold">
      PERSONAL DATA PROTECTION POLICY OF THE PIERRE FABRE GROUP
    </h1>

    <p>
      Thank you for visiting our website. The protection and security of the personal data of our customers
      and users is a key concern for the Pierre Fabre Group.<br>
      This Privacy Policy explains what data is collected when you consult and use our website and how it is
      processed.
    </p>

    <h2>I. Who are we?</h2>
    <p>
      This website (hereinafter the "Website") is operated by Pierre Fabre S.A., Parc Industriel de la Chartreuse, 40 Rue Albert Calmette, 81100 Castres, France (hereinafter referred to as "Pierre Fabre" or "We"), which is responsible for processing personal data that may be collected from you on the Internet Site for the purposes described below.<br>
      We invite you to read this Privacy Policy carefully in order to know the conditions for processing your
      personal data when you consult our Website. Please note that it may be updated at any time by
      Pierre Fabre. The date of the most recent update will appear on this page. We therefore invite you to
      consult it regularly.
    </p>

    <h2> II. Information we collect about you</h2>
    <p>
      Depending on the services on our Website that you use and your choice of terminal configuration (in
      particular with regard to cookies and other trackers), the personal data concerning you (hereinafter
      referred to as "your Personal Data") collected and processed by Pierre Fabre are :<br><br>

      Data that you have voluntarily entered in a form (newsletter registration, contact, participation in a
      promotional operation (competitions, games or surveys) such as :<br>
      Last and first name, e-mail address, telephone number, date of birth, gender, postal address and
      any other information about you provided by you in the context of your application (which may
      include health and welfare data).<br>
      The data generated by your browser, collected automatically by our server through "cookies and
      other tracers":<br>
      Data specific to the sites visited: the domain name; the date, time and duration of your visit; the
      pages and videos consulted, the advertisements on which you clicked.
      Data specific to you: your IP address (location of your entry point on the network; type of browser,
      operating system), .<br><br>
      We do not use this automatically collected Personal Data to try to identify you, nor do we correlate it
      with the Personal Data detailed above that you provide to us.
    </p>

    <h2>III. Purposes of the processing of your Personal Data</h2>
    <p>
      You will find below an overview of the purposes for which we process your Personal Data
      and the reasons why we need to process them.
    </p>

    <table class="my-3">
      <tr>
        <th>Purposes of the processing</th>
        <th>Legal basis associated</th>
      </tr>

      <tr>
        <td>Answering your questions sent by e-mail, contact form and chat</td>
        <td rowspan="5">Our legitimate interest</td>
      </tr>
      <tr>
        <td>Enable you to find the closest shop or point of sale to your location</td>
      </tr>
      <tr>
        <td>Carry out statistical analyses</td>
      </tr>
      <tr>
        <td>Unless you object as indicated in the section below "Your rights" and "Cookies", better understand your preferences by analyzing your behavior on our Website and offer you products or services more in line with your interests</td>
      </tr>
      <tr>
        <td>Adapt our response to your needs by offering you products or services more adapted to your field of interest.</td>
      </tr>

      <tr>
        <td>Send to you information about our offers, news and events (newsletters, invitations and other publications).</td>
        <td>Your consent</td>
      </tr>
      <tr>
        <td>Notify the competent authorities of any problem related to the use of our products.</td>
        <td>Our legal obligations</td>
      </tr>
    </table>

    <p>
      The Personal Data that is essential for us to carry out the above-mentioned purposes is
      indicated by an asterisk on the various pages of the Website where it is collected.
      If you choose not to fill in these mandatory fields, we may not be able to process your
      requests and/or provide you with the products and services requested. Other Personal Data
      is purely optional and enables us to get to know you better and to improve our
      communication and services accordingly.
    </p>

    <h2>IV. Communication and Transfer of personal data</h2>
    <p>
      We are part of the worldwide Pierre Fabre Group, and from time to time we may need to
      communicate your Personal Data within the Pierre Fabre Group for the purposes set out
      above.<br><br>

      We may also appoint third party service providers (who will act in accordance with our
      instructions) to assist us in providing you with information, products or services, to conduct
      and manage our business, or to manage and improve our Website. In such a case, these
      third parties may need to access your Personal Data.
      If your Personal Data is transferred outside the EEA (European Economic Area) to other
      companies of the Pierre Fabre Group or to service providers, we will take steps to ensure
      that your Personal Data benefits from the same level of protection as if it had remained
      within the EEA, including by concluding data transfer contracts, on the basis of the standard
      contractual clauses approved by the European Commission as updated or revised or other
      transfer mechanisms such as, where applicable, adequacy decisions, Binding Corporate Rules
      or contracts approved by the EU Data Protection Authorities.<br><br>

      We may also disclose your Personal Data to third parties in connection with any actual or
      potential sale of Pierre Fabre or any assets owned by us or affiliated companies, in which
      case the Personal Data we hold on our users may be those of the transferred assets.<br><br>

      We will also respond to requests for information if we are required to do so by law, or if such
      disclosure is necessary to protect our rights and/or to comply with a court order, a request
      from a regulator or any other legal or administrative proceeding against us.
    </p>

    <h2>V. Retention of your Personal Data</h2>
    <p>
      As a rule, we keep your Personal Data only for as long as is necessary to fulfil the purposes
      for which it was collected.<br><br>

      We keep your Personal Data only for the time strictly necessary to manage the relationship
      with you. (
      However, we will retain your Personal Data for marketing purposes for three years from the
      date of the last interaction between us if you are not a customer and as long as we remain in
      contact with you through our promotional activities if you are a customer, unless you object
      when you receive one of our marketing messages.<br><br>

      IP addresses collected for security purposes will not be retained for more than 10 days.
      Finally, the connection logs that are collected will be kept if you consent, using cookies and
      other trackers used on our Website, for a period not exceeding thirteen (13) months in
      accordance with applicable laws and regulations. For more details, please refer to the
      "Cookies" section below.<br><br>

      We may need to retain your Personal Data in archival form beyond the period indicated
      below in order to comply with our legal obligations or, if necessary in view of the applicable
      prescription, to enforce one of our rights.<br><br>

      Once your Personal Data is no longer required for the purposes or for archiving purposes to
      meet our legal obligations or for the statute of limitations, we ensure that it is destroyed or
      made anonymous.
    </p>

    <h2>VI. External Links</h2>
    <p>
      The Website may contain links to third party sites. As Pierre Fabre has no control over these
      sites and is not responsible for their data protection practices, we encourage you to check
      the data protection policies of these third-party sites. This policy applies solely to Personal
      Data collected by our Websites or during our activities.
    </p>

    <h2>VII. Your Rights</h2>
    <p>
      In accordance with applicable regulation, you have the following rights with respect to your
      Personal Data:
    </p>

   <p>
     - Obtain a copy of your Personal Data, information on the processing methods and their legal
     basis.<br>
     - Rectify erroneous Personal Data (including the right to complete incomplete Personal
     Data);<br>
     - Delete your Personal Data as far as the legal basis allows it . Moreover, in some cases this
     right may only apply when it is no longer necessary to achieve the purposes for which it was
     collected or processed;<br>
     - Restrict the processing of your Personal Data when:<br>
     - The accuracy of the Personal Data is disputed;<br>
     - The processing is unlawful, but you object to the deletion of your Personal Data.<br>
     - We no longer need your Personal Data, but they are still necessary for the
     establishment, exercise or defines of a right in court.<br>
     - Request portability of your Personal Data in machine-readable form to a third party (or to
     you) if our processing is based on your consent or the performance of a contract with you.<br>
     - Obtain or consult a copy of the appropriate measures taken to transfer your Personal Data
     to a third country or to an international organization.<br>
     - Withdraw your consent to the processing of your Personal Data (if such processing is based
     on your consent) without prejudice to the lawfulness of the processing based on consent
     carried out prior to the withdrawal of such consent.<br>
     - Give general or specific instructions on how your Personal Data will be processed and used
     after your death.<br>
     - Oppose you at any time to the processing for canvassing purposes. To avoid any telephone
     contact, register free of charge on the Website http://www.bloctel.gouv.fr/.<br>
     - In addition to the above-mentioned rights, you have the right to object to any processing of your Personal Data justified by Pierre Fabre's legitimate interest, including profiling (contrary
     to a justification by your consent, or to execute a contract with you).<br><br>

     You also have the right to file a complaint with your local data protection supervisory
     authority.<br><br>

     To exercise these rights, please contact us using the contact details below, under the
     heading "Contact us". Please note that we may ask you for proof of identity, and we reserve
     the right to charge a fee if we are permitted to do so by law, for example if your request is
     manifestly unfounded or excessive. We will endeavour to respond to your request within the
     applicable timeframe.
   </p>

    <!-- OneTrust Cookies List start -->
    <div id="ot-sdk-cookie-policy"></div>
    <!-- OneTrust Cookies List end -->

    <h2>IX. Updating of the Privacy Policy</h2>
    <p>
      We may amend this Privacy Policy at any time to reflect changes in the law and/or our privacy
      practices.
    </p>

    <h2>X. Contact information</h2>
    <p>
      If you have any questions about this Privacy Policy or if you wish to exercise any of your rights, please
      contact our Data Protection Officer at <a href="mailto:dpofr@pierre-fabre.com">dpofr@pierre-fabre.com</a>.
    </p>

    <h2>Credits :</h2>
    <p>
      CYCA Creative Hub / Loïc Martinez : Direction de Création, Direction Artistique, Pilotage du projet.<br>
      Joelle Parry : Rédaction médicale.<br>
      Jules Le Barazer : Illustrations.<br>
      <a href="https://www.agencegardeners.com/" target="_blank">Agence Gardeners</a> : UX, Graphisme, Développement web.<br><br>
    </p>

    <p>
      Last modified: 01/01/2023
    </p>
  </section>


  <CookieComponents lang="en"/>
</template>

<style lang="scss">
  .policy {
    text-align: left;
  }

  table td, table th {
    border: 1px solid;
    padding: 10px;
  }
</style>
<script>
import CookieComponents from '../components/CookieComponents'

export default {
  name: 'ENPolicyView',
  components: {
      CookieComponents
  }
}
</script>